import { useQuery, useMutation } from '@apollo/client/react'
import {
  GET_MY_PIPELINE_CONFIG,
  UPSERT_MY_PIPELINE_CONFIG,
  DELETE_MY_PIPELINE_CONFIG,
} from '@/lib/operations/pipelineConfig'
import type { ClientPipelineConfig } from '@/lib/types'

export function useMyPipelineConfig(pipeline: string) {
  const { data, loading, error } = useQuery<{ myPipelineConfig: ClientPipelineConfig | null }>(
    GET_MY_PIPELINE_CONFIG,
    { variables: { pipeline } }
  )
  return { config: data?.myPipelineConfig ?? null, loading, error }
}

export function useUpsertMyPipelineConfig() {
  const [mutate, { loading }] = useMutation<{ upsertMyPipelineConfig: ClientPipelineConfig }>(UPSERT_MY_PIPELINE_CONFIG)
  const upsert = (pipeline: string, config: Record<string, unknown>) =>
    mutate({
      variables: { pipeline, config },
      refetchQueries: [{ query: GET_MY_PIPELINE_CONFIG, variables: { pipeline } }],
    })
  return { upsert, loading }
}

export function useDeleteMyPipelineConfig() {
  const [mutate, { loading }] = useMutation<{ deleteMyPipelineConfig: boolean }>(DELETE_MY_PIPELINE_CONFIG)
  const reset = (pipeline: string) =>
    mutate({
      variables: { pipeline },
      refetchQueries: [{ query: GET_MY_PIPELINE_CONFIG, variables: { pipeline } }],
    })
  return { reset, loading }
}
